import { AsyncResult, CommerceList } from '@msdyn365-commerce/retail-proxy';
import { comparer, reaction, toJS } from 'mobx';
import { useEffect, useState } from 'react';

interface CustomerWishlistState {
    wishlist: CommerceList | undefined;
    status: AsyncResult<CommerceList[]>['status'] | undefined;
}

const getWishlistState = (wishlists: AsyncResult<CommerceList[]> | undefined): CustomerWishlistState => ({
    wishlist: wishlists?.result?.length ? toJS(wishlists.result[0]) : undefined,
    status: wishlists?.status
});

export const useCustomerWishlist = (wishlists: AsyncResult<CommerceList[]> | undefined): CustomerWishlistState => {
    const [state, setState] = useState(() => getWishlistState(wishlists));

    useEffect(() => {
        if (typeof window === 'undefined') {
            return;
        }

        return reaction(
            () => getWishlistState(wishlists),
            nextState => setState(nextState),
            { fireImmediately: true, equals: comparer.structural }
        );
    }, [wishlists]);

    return state;
};
